import type { FaireProductEntity } from "../../entity_types/product";

export const p_yfvmz8seww: FaireProductEntity = {
  token: "p_yfvmz8seww",
  type: "product",
  name: "Ojai Lavender - 7.75 fl oz Room & Linen Spray",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl: "https://cdn.faire.com/fastly/82dd9a5431ef5b8900c6eeebfb99a77c428b88e70cf2a360496969a02f3530f0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bb0b6a8c2c37625a912e31969446112a91e70a4add9fbed7b83488d39ce0621.jpeg",
    "https://cdn.faire.com/fastly/ef512fe0f8022269d319a014962d70e334e8cc37690374e9317712f6092068d5.jpeg",
    "https://cdn.faire.com/fastly/b6188a386979dc788f1fe59b183e1907210feb116cbef57eb3b3cda5e9f5c5c9.jpeg",
    "https://cdn.faire.com/fastly/be83086637055d198072996a2ce0bdc87fff96d78ae5cd50c79a3d9c1dce9448.jpeg",
    "https://cdn.faire.com/fastly/c8204198990372227fbca763174af767f6553facc4394d12aa05d2aec7aa9d35.jpeg",
    "https://cdn.faire.com/fastly/92c380a966cb4b7aa888644ea633272196abffc9515d6589e28c4e7bc1f82fdd.jpeg",
    "https://cdn.faire.com/fastly/bc5a0c814899f777c13d6bdd067084d1a868270b280ceb550a2f0c344844dee1.jpeg"
  ],
  priceDollars: 10,
  description: "Sun-drenched fields, orange groves and lavender farms, jagged mountains washed in a rosy, sunset glow. Pixie tangerine, lavender, mint.\n\nOur Room & Linen Sprays offer an effortless, fine mist with a light fragrance! Meant for daily use on bedsheets, pillows, couches - anywhere that needs a bit of a boost. \n\nFragrance lasts longest when applied directly onto fabrics, especially any with a thicker weave.\n\nEach 7.75 oz amber bottle contains water, phthalate-free premium fragrance oil (body safe), and two cosmetic-grade preservatives meant to maintain quality and prolong shelf-life: phenoxyethanol and caprylyl glycol.\n\nYour customers might also like fresh Amber & Moss or beachy Golden Coast.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:52.863Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
